<template>
  <v-container fluid grid-list-sm>
    <div class="text-center font-weight-bold ma-1 text-h6"> {{ $t('restaurants') }}</div>
    <v-layout v-if="pointOfSaleList.length > 0" row wrap justify-space-around>
      <dynameat-card v-for="pointOfSale in pointOfSaleList" :key="pointOfSale.guid"
                     :logo-url="pointOfSale.logo" :title="pointOfSale.name"
                     @click.native="onSelectPointOfSale(pointOfSale)"/>
    </v-layout>
    <v-layout class="mt-5" v-if="pointOfSaleList.length === 0" row wrap justify-space-around>
      <h2 class="text-center">{{ $t('noPointOfSale') }}</h2>
    </v-layout>
  </v-container>
</template>
<script>

import DynameatCard from '@dynameat/components/DynameatCard';
import Vue from 'vue';
import {
  Components, MapActions, MapGetters, Name
} from '@core/helpers/decorators';
import Component from 'vue-class-component';

@Component
@Components({ DynameatCard })
@MapGetters(['pointOfSaleList'])
@MapActions(['setSelectedPointOfSaleGuid'])
export default class Dashboard extends Vue {
  @Name 'dashboard'

  shownPriceNotification = false;

  async onSelectPointOfSale(pointOfSale) {
    await this.setSelectedPointOfSaleGuid(pointOfSale.guid);
    await this.$router.push({ name: 'restaurant-management', params: { pointOfSaleGuid: pointOfSale.guid } });
  }
}
</script>
